import type { About, ArticlePreview } from "@brookbush/types";

import { ChevronRight } from "lucide-react";
import Link from "next/link";
import useSWR, { type SWRResponse } from "swr";

import AboutArticlesCard from "./AboutArticlesCard";
import Header from "~/components/Header";
import SectionContainer from "~/components/SectionContainer";
import fetcher from "~/utils/fetcher.client";

const AboutResources = () => {
	const { data: about } = useSWR<About>(
		"/company-info/about",
		fetcher,
	) as SWRResponse<About> & {
		data: About;
	};

	const { aboutArticleResources } = about;
	if (!aboutArticleResources?.length) return null;

	return (
		<SectionContainer
			className="border-t bg-slate-50 dark:bg-slate-800"
			id="team"
			aria-labelledby="team-title"
		>
			<Header
				id="about-resources"
				title="Certification & Accreditation Articles"
				description="Learn more about the certifications and accreditations we offer."
			/>

			<div className="relative grid gap-8 px-8 py-10 xl:grid-cols-2">
				{aboutArticleResources.map((article) => (
					<AboutArticlesCard
						article={article as ArticlePreview}
						key={article.slug}
					/>
				))}
			</div>

			<Link
				className="mx-auto flex max-w-max items-center gap-1 rounded-full bg-slate-100 px-4 py-2 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600"
				href="/articles/categories/certification-and-accreditation"
			>
				<span>More resources</span>
				<ChevronRight size={20} />
			</Link>
		</SectionContainer>
	);
};

export default AboutResources;
